


































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import InViewport from '~/mixins/InViewport';

@Component
export default class AboutUsQuotes extends Mixins(InViewport) {
  @Watch('inViewport.now', { immediate: true })
  handleInViewportChange(val: boolean, oldVal: boolean) {
    if (val) {
      this.$lax.addElements('.quote-container.lax', {
        scrollY: {
          translateY: [
            ['elInY', 'elCenterY+100'],
            ['-elHeight/5', 0],
          ],
        },
      });
    } else if (oldVal && !val) {
      this.$lax.removeElements('.quote-container.lax');
    }
  }
}
